









import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'

export interface PayPalButtonOrderFactory {
  (): Promise<string>
}

export interface AsyncPayPalButtonCallback {
  (orderId: string): Promise<void>
}

@Component
export default class PayPalButton extends Vue {
  @Prop({ type: String, required: true })
  readonly currency!: string

  @Prop({ type: Function, required: true })
  readonly createOrder!: PayPalButtonOrderFactory

  @Prop({ type: Function })
  readonly onApprove!: AsyncPayPalButtonCallback

  @Prop({ type: Function })
  readonly onComplete!: AsyncPayPalButtonCallback

  @Emit('error')
  onError(err: Error) {
    return err
  }

  @Emit('cancel')
  onCancel() {
    return this
  }

  @Watch('$props', { deep: true, immediate: true })
  onPropsChanged() {
    this.init()
  }

  loading: boolean = true

  mounted() {
    this.init()
  }

  init() {
    if (this.currency.length !== 3) {
      return
    }

    this.loading = true

    const el = document.getElementById(this.buttonId)
    if (el) el.innerHTML = ''

    const scriptEl = document.createElement('script')
    const query = new URLSearchParams({
      'client-id': process.env.VUE_APP_PAYPAL_CLIENT_ID!,
      currency: this.currency,
      debug: process.env.NODE_ENV !== 'production' ? 'true' : 'false',
      'integration-date': '2021-10-20',
      intent: 'capture',
      'disable-funding': 'card',
      locale: this.locale
    })

    scriptEl.src = 'https://www.paypal.com/sdk/js?' + query.toString()
    scriptEl.addEventListener('load', () => {
      this.loading = false

      window.paypal
        .Buttons({
          createOrder: this.createOrder,
          onApprove: async ({ orderID }: any) => {
            if (this.onApprove) {
              await this.onApprove(orderID as string)
            }
            if (this.onComplete) {
              await this.onComplete(orderID as string)
            }
          },
          onCancel: async () => {
            this.onCancel()
          },
          onError: (err: Error) => {
            console.error(err)
            this.onError(err)
          }
        })
        .render('#' + this.buttonId)

      scriptEl.remove()
    })
    scriptEl.addEventListener('error', () => {
      this.loading = false
    })
    document.body.appendChild(scriptEl)
  }

  get buttonId() {
    const { _uid } = this as any
    return `paypal-btn-${_uid}`
  }

  get locale() {
    if (this.$i18n.locale === 'tc') return 'zh_TW'
    return 'en_US'
  }
}
